import React, { useEffect } from "react";
import NavigationBar from "../Components/NavigationBar";
import LegalTexts from "./LegalTexts";

function ComplianceNotice({ theme = "", showMenu = true, product = "TEL" }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={"terms " + theme}>
      <NavigationBar showMenu={showMenu} />
      <div className="legal-texts">
        <h1>2257 Compliance Notice</h1>
        <br />
        <br />
        <p>
          18 U.S.C. Section 2257 Compliance Notice All models, actors, actresses
          and other persons that appear in any visual depiction of actual
          sexually explicit conduct appearing or otherwise contained in this
          Website were over the age of eighteen years at the time of the
          creation of such depictions.
        </p>
        <br />
        <p>
          All other visual depictions displayed on this Website are exempt from
          the provision of 18 U.S.C. section 2257 and 28 C.F.R. 75 because said
          visual depictions do not consist of depictions of conduct as
          specifically listed in 18 U.S.C section 2256 (2) (A) through (D), but
          are merely depictions of non-sexually explicit nudity, or are
          depictions of simulated sexual conduct, or are otherwise exempt
          because the visual depictions were created prior to July 3, 1995.
        </p>
        <br />
        <p>
          With respect to all visual depictions displayed on this website,
          whether of actual sexually explicit conduct, simulated sexual content
          or otherwise, all persons in said visual depictions were at least 18
          years of age when said visual depictions were created.
        </p>
        <br />
        <p>
          The owners and operators of this Website are not the primary producer
          (as that term is defined in 18 USC section 2257) of any of the visual
          content contained in the Website.
        </p>
        <br />
        <p>
          The original records required pursuant to 18 U.S.C. section 2257 and
          28 C.F.R. 75 for all materials contained in the website are kept by
          the following Custodian of Records:
        </p>
        <br />
        <br />
        <p>VISIT-X B.V.</p>
        <p>IJburglaan 634E</p>
        <p>1087 CE Amsterdam</p>
        <p>Netherlands</p>
      </div>
    </div>
  );
}

export default ComplianceNotice;
